import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  BLOCK_UNBLOCK_SWITCH,
  GET_USER,
  GET_HISTORY,
  EDIT_COIN,
  GET_USER_BAN,
  ADJUST_DAILY_DIAMOND_CAP,
  TOGGLE_USER_VERIFICATION,
  RESET_USER_IDENTITY,
  OPEN_DAILY_DIAMOND_LIMIT_DIALOG,
  CLOSE_DAILY_DIAMOND_LIMIT_DIALOG,
  SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA,
} from "./types";
import { baseURL, key } from "../../util/Config";
import { UPDATE_USER_INFO } from "../post/types";
import { getStoredSession } from "../../util/adminSession";

export const getUser =
  (start, limit, searchValue, sDate, eDate) => (dispatch) => {
    const token = getStoredSession()?.token;
    const requestOptions = {
      method: "GET",
      headers: { key: key, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
    fetch(
      `${baseURL}admin/users?start=${start}&limit=${limit}&search=${searchValue}&startDate=${sDate}&endDate=${eDate}`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.status) {
          console.log("getUser response:", res);
          let male, female;
          if (res.maleFemale) {
            // eslint-disable-next-line
            res.maleFemale.map((data) => {
              if (data._id === "Female") return (female = data.gender);
              if (data._id === "Male") return (male = data.gender);
            });
          }
          dispatch({
            type: GET_USER,
            payload: {
              user: res.user,
              activeUser: res.activeUser,
              total: res.total,
              male: male,
              female: female,
            },
          });
        } else {
          Toast("error", res.message);
        }
      })
      .catch((error) => Toast("error", error.message));
  };

export const handleBlockUnblockSwitch = (userId) => (dispatch) => {
  axios
    .patch(`blockUnblock/${userId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: BLOCK_UNBLOCK_SWITCH, payload: res.data.user });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const getUserBan = (userId) => (dispatch) => {
  console.log("getUserBan called with userId: ", userId);
  axios
    .get(`/user/getUserBan?userId=${userId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_USER_BAN, payload: res.data.user });
        console.log("getUserBan response: ", res.data.user);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const handleGameBlockUnblockSwitch = (userId) => (dispatch) => {
  axios
    .put(`gameBlock?userId=${userId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: BLOCK_UNBLOCK_SWITCH, payload: res.data.user });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const userHistory = (data) => (dispatch) => {
  axios
    .post(`history`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_HISTORY, payload: res.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const adjustDailyDiamondCap =
  (userId, dailyDiamondLimit) => (dispatch) => {
    const data = {
      userId,
      dailyDiamondLimit,
    };
    axios
      .post(`/adjustDailyDiamondCap`, data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ADJUST_DAILY_DIAMOND_CAP,
            payload: res.data.user,
          });
          Toast("success", res.data.message);
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((error) => Toast("error", error.message));
  };

export const toggleUserVerification = (userId) => (dispatch) => {
  return axios
    .post("/user/toggleIsVerified", { userId })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: TOGGLE_USER_VERIFICATION,
          payload: res.data.user,
        });
        dispatch({ type: UPDATE_USER_INFO, payload: res.data.user });
        Toast("success", res.data.message);
        return res.data.user;
      } else {
        Toast("error", res.data.message);
        return null;
      }
    })
    .catch((error) => {
      Toast("error", error.message);
      return null;
    });
};

export const resetUserIdentity = (userId) => (dispatch) => {
  return axios
    .post("/user/resetIdentity", { userId })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: RESET_USER_IDENTITY,
          payload: res.data.user,
        });
        dispatch({ type: UPDATE_USER_INFO, payload: res.data.user });
        Toast("success", res.data.message);
        return res.data.user;
      } else {
        Toast("error", res.data.message);
        return null;
      }
    })
    .catch((error) => {
      Toast("error", error.message);
      return null;
    });
};

export const adminUpdateUser = (data) => (dispatch) => {
  return axios
    .post("/admin/user/update", data)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_USER_INFO, payload: res.data.user });
        Toast("success", `${res.data.user.name}'s Profile Update Successful`);
        return res.data.user;
      }

      Toast("error", res.data.message);
      return null;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return null;
    });
};

export const resetUserImage = (userId, type) => (dispatch) => {
  return axios
    .post(`/admin/user/resetImage?type=${type}&userId=${userId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_USER_INFO, payload: res.data.user });
        Toast("success", `${res.data.user.name}'s Profile Update Successful`);
        return res.data.user;
      }

      Toast("error", res.data.message);
      return null;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return null;
    });
};

export const editCoin = (data) => (dispatch) => {
  axios
    .post(`/user/addLessCoin`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: EDIT_COIN,
          payload: { data: res.data.user, id: data.userId },
        });
        Toast("success", "Update Successful!!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const adjustUserBalance = (user, balanceType, adjustment) => (dispatch) => {
  const isDiamond = balanceType === "diamond";
  const endpoint = isDiamond ? "/adjustUserDiamonds" : "/adjustUserVCoins";
  const payload = {
    uniqueId: user.uniqueId,
    [isDiamond ? "diamond" : "vCoin"]: adjustment,
  };

  return axios
    .post(endpoint, payload)
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return null;
      }
      dispatch({ type: UPDATE_USER_INFO, payload: res.data.user });
      Toast("success", res.data.message);
      return res.data.user;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return null;
    });
};

export const restrictUser = (user) => (dispatch) => {
  return axios
    .post("/restrictedAccount", {
      uniqueId: user.uniqueId,
      reason: "Restricted by Admin",
    })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }
      dispatch({
        type: UPDATE_USER_INFO,
        payload: {
          isRestricted: true,
          accountStatus: {
            ...(user.accountStatus || {}),
            isRestricted: true,
            restriction: res.data.restrictedAccount,
          },
        },
      });
      Toast("success", res.data.message);
      return true;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return false;
    });
};

export const resetUserName = (data) => (dispatch) => {};

export const resetBio = (data) => (dispatch) => {};

export const resetBackgroundImage = (data) => (dispatch) => {};

export const resetProfileImage = (data) => (dispatch) => {};

export const openDailyDiamondLimitDialog = (userData) => (dispatch) => {
  dispatch({
    type: SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA,
    payload: userData,
  });
  dispatch({
    type: OPEN_DAILY_DIAMOND_LIMIT_DIALOG,
  });
};

export const closeDailyDiamondLimitDialog = () => (dispatch) => {
  dispatch({
    type: CLOSE_DAILY_DIAMOND_LIMIT_DIALOG,
  });
};
